import { render, staticRenderFns } from "./PromotionLastMinutNewForm.vue?vue&type=template&id=6ea99c12&scoped=true&"
import script from "./PromotionLastMinutNewForm.vue?vue&type=script&lang=js&"
export * from "./PromotionLastMinutNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea99c12",
  null
  
)

export default component.exports